import React from "react";
import { PriceTypeDetail } from "../../../components/Pages/Catalogs/PriceType/PriceTypeDetail";
import PriceTypeList from "../../../components/Pages/Catalogs/PriceType/PriceTypeList";
import { NFLookupPriceType } from "../../../components/Shared/NewForms/NFLookupPriceType";
import { CreatePriceTypeDto } from "../../../dtos/catalogs/pricetype/CreatePriceTypeDto";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { PriceTypeService } from "../../../services/catalogs/PriceTypeService";
import { IAppEntity } from "../../entities";

export const PriceType: IAppEntity = {
  entityType: "catalog",
  title: "PriceType",
  pluralTitle: "PriceType",
  apiUrl: "PriceTypes",
  apiEnum: ReferenceTypes.CatalogPriceType,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(PriceTypeDetail, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(PriceTypeList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupPriceType, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () => new PriceTypeService("PriceTypes"),
  getEmptyModel: () => {
    const model: CreatePriceTypeDto = {
      name: "",
      createdDate: new Date(),
      description: "",
      status: 0,
      group: "",
      // currencyId: "",
      priceIncludesVat: false,
    };
    return model;
  },
};
